import React, { useEffect, useRef } from "react";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import Avatar from "@mui/joy/Avatar";
import Sheet from "@mui/joy/Sheet";
import Chip from "@mui/joy/Chip";
import Button from "@mui/joy/Button";
import CajaTexto from "./cajatexto";
import MensajeChatAmigo from "./mensajechatamigo";
import MensajeChatCuenta from "./mensajechatcuenta";

export default function ContenidoChat({
  foto_amigo,
  foto_usuario,
  conversacion,
}) {
  /* Se desplaza hasta el ultimo mensaje */

  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [conversacion.chat]); // Esto se activará cada vez que la conversación cambie

  /* Se desplaza hasta el ultimo mensaje */

  return (
    <div>
      <Sheet sx={{ height: "100%" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              padding: 2,
              marginLeft: { md: 10, xs: 2 },
              marginRight: { md: 10, xs: 2 },
              marginTop: 3,
            }}
          >
            {conversacion.chat
              ? conversacion.chat.map((x, index) => {
                  if (conversacion.usuarioprincipal === x.id_usuario)
                    return (
                      <MensajeChatCuenta
                        foto_cuenta={foto_usuario}
                        mensaje_chat_cuenta={x.mensaje}
                        key={index}
                      />
                    );
                  if (conversacion.usuarioamigo === x.id_usuario)
                    return (
                      <MensajeChatAmigo
                        foto_amigo={foto_amigo}
                        mensaje_chat_amigo={x.mensaje}
                        key={index}
                      />
                    );
                })
              : null}
            {conversacion.chat ? <div ref={messagesEndRef} /> : null}
            {/* Este es el contenedor para el scroll */}
          </Box>
          <Box
            sx={{
              margin: { md: 10, xs: 0 },
              marginTop: 0,
            }}
          >
            <CajaTexto />
          </Box>
        </Box>
      </Sheet>
    </div>
  );
}
